import classNames from 'classnames';
import { useRouter } from 'next/router';
import Image from 'next/image';

import { SectionTitle, ActiveLink } from '@/ui/index';
import { ArrowRight } from '@/icons/index';

import styles from './ChooseCategory.module.scss';

const renderCategory = (item, key) => (
  <div
    className={styles.category}
    key={key}
    itemScope
    itemType='https://schema.org/Property'
  >
    <ActiveLink href={item?.slug}>
      <a className={styles.link} title={item?.title} aria-label={item?.title}>
        <span className={styles.name}>{item?.title}</span>
        <span className={styles.arrow}>
          <ArrowRight />
        </span>
      </a>
    </ActiveLink>
  </div>
);

const RenderItem = (item, key) => {
  const router = useRouter();
  const categories = item?.groups?.map((cat) => ({
    ...cat,
    link: `${router.asPath}/${item?.slug}/${cat?.id}`,
  }));

  return (
    <div
      className={styles.item}
      key={key}
      itemScope
      itemType='https://schema.org/ListItem'
    >
      <div className={`${styles.titleBlock} grid-extend`}>
        <div
          className={styles.icon}
          style={{
            background: router?.asPath?.startsWith('/business')
              ? '#333'
              : '#f4f4f4',
          }}
        >
          <Image
            src={item?.icon}
            alt='icon'
            title='icon'
            loading='lazy'
            layout='fill'
          />
        </div>

        <div className={styles.name}>{item?.title}</div>

        <div className={styles.link}>
          <ActiveLink href={`${router.asPath}/${item?.slug}`}>
            <a
              className={styles.link}
              title={item?.button_text}
              aria-label={item?.button_text}
            >
              {item?.button_text}
            </a>
          </ActiveLink>
        </div>
      </div>

      {categories?.length > 0 && (
        <div className={`${styles.categories} grid-extend`}>
          {categories.map(renderCategory)}
        </div>
      )}
    </div>
  );
};

const ChooseCategory = ({ data, dark = false, className }) => {
  return (
    <div className={className} itemScope itemType='https://schema.org/ItemList'>
      <SectionTitle
        className={styles.title}
        icon={data?.icon}
        titleModify='title--large'
      >
        {data?.title}
      </SectionTitle>
      {data?.items?.length > 0 && (
        <div
          className={classNames([
            styles.list,
            'grid-extend',
            'equal',
            { [styles.dark]: dark },
          ])}
        >
          {data.items.map(RenderItem)}
        </div>
      )}
    </div>
  );
};

export default ChooseCategory;
